import React from 'react';

// Metric (§26) — número editorial grande (usado na coluna "Visão
// financeira" do Dashboard, §20). Diferente do KpiCard (que é uma célula
// de grade uniforme): Metric é pensado pra hierarquia — um número
// "manchete" com rótulo acima e uma nota secundária opcional abaixo.
export function Metric({ label, value, hint, size = 'lg', tone }) {
  return (
    <div className="crm-metric">
      <div className="crm-metric-label">{label}</div>
      <div className={`crm-metric-value crm-metric-${size}${tone ? ` crm-metric-${tone}` : ''}`}>{value}</div>
      {hint && <div className="crm-metric-hint">{hint}</div>}
    </div>
  );
}

export default Metric;
